import{a as e}from"./chunk-RAAYCPUM.js";function r(...t){return e(Object.values,t)}export{r as a};
